import React from 'react'
import {createRoot} from 'react-dom/client'
import './index.css'
import App from './App'
import {MsalProvider} from '@azure/msal-react'
import {Provider} from './contexto/ContextoAplicacion'
import moment from 'moment'
import 'moment/locale/es'
import {getMsalInstance, initializeMsal} from './msalService'

moment.locale('es')

initializeMsal()
  .then(() => {
    const msalInstance = getMsalInstance()
    const root = createRoot(document.getElementById('root'))

    root.render(
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <Provider>
            <App />
          </Provider>
        </MsalProvider>
      </React.StrictMode>
    )
  })
  .catch((error) => {
    console.error('Failed to load app configuration', error)
  })
